import api from "@/libs/axios";

export default {
  async create(payload) {
    const response = await api.post(
      "/admin/social-game/breaking-quiz",
      payload
    );
    return response || null;
  },

  async update(payload) {
    let response = await api.put("/admin/social-game/breaking-quiz", payload);
    return response;
  },

  async delete(payload) {
    const response = await api.delete("/admin/social-game/breaking-quiz", {
      data: payload
    });
    return response;
  },

  async getList(params) {
    let response = await api.get("/admin/social-game/breaking-quiz", {
      params
    });
    return response.data.data;
  },

  async get(params) {
    let response = await api.get("/admin/social-game/breaking-quiz/detail", {
      params
    });
    return response.data.data.document || null;
  },
  async import(payload) {
    let response = await api.post(
      "/admin/social-game/breaking-quiz/import",
      payload
    );
    return response;
  },
  async replace(payload) {
    let response = await api.post(
      "/admin/social-game/breaking-quiz/replace",
      payload
    );
    return response;
  }
};
